import React from "react";
import { connect } from "react-redux";
import ReactGA from "react-ga";

import { message, setTitleAndScrollToTop } from "../actions";
import { anonymizeIban, deleteOrganization, getOrganization, getOrganizationsOverview, patchOrganization } from "../plugins/questionnaires/actions/Organizations";
import { exportOrganizationBilling, exportOrganizationsBilling } from "../actions/Billings";
import Overview from "../components/Overview";
import Access from "../components/Access";
import Icon from "../components/Icon";
import Form from "../components/Form";
import { translations } from "../config";
import { checkIBAN } from "../actions/Users";
import { getUpdatedValues } from "../components/HandleHelper";

const mapStateToProps = ( state ) =>
{
	return {
		organizations: state.organizations,
		user: state.user
	};
};

const mapDispatchToProps = ( dispatch ) =>
{
	return {
		getOrganizationsOverview: () =>
		{
			dispatch( getOrganizationsOverview() );
		},
		getOrganization: ( a_formData, a_format ) =>
		{
			dispatch( getOrganization( a_formData, a_format ) );
		},
		patchOrganization: ( a_formData, a_udatedSet ) =>
		{
			dispatch( patchOrganization( a_formData, a_udatedSet ) );
		},
		deleteOrganization: ( a_id ) =>
		{
			dispatch( deleteOrganization( a_id ) );
		},
		anonymizeIban: ( a_udatedSet ) =>
		{
			dispatch( anonymizeIban( a_udatedSet ) );
		},
		exportOrganizationBilling: ( a_formData ) =>
		{
			dispatch( exportOrganizationBilling( a_formData ) );
		},
		exportOrganizationsBilling: ( a_formData ) =>
		{
			dispatch( exportOrganizationsBilling( a_formData ) );
		},
		setTitleAndScrollToTop: ( title ) =>
		{
			dispatch( setTitleAndScrollToTop( title ) );
		},
		checkIBAN: ( a_formData ) =>
		{
			return dispatch( checkIBAN( a_formData ) );
		},
		message: ( a_message, a_type, a_timeout ) =>
		{
			dispatch( message( a_message, a_type, a_timeout ) );
		}
	};
};

/**
 * Komponente um statische Inhalte auszugeben
 */
class OrganizationManagement extends React.Component
{
	// aktuelle Zeit
	currentTime = new Date();
	
	// Monate
	defaultBillingMonthOptions = [
		{ value: "1", title: "Januar" },
		{ value: "2", title: "Februar" },
		{ value: "3", title: "März" },
		{ value: "4", title: "April" },
		{ value: "5", title: "Mai" },
		{ value: "6", title: "Juni" },
		{ value: "7", title: "Juli" },
		{ value: "8", title: "August" },
		{ value: "9", title: "September" },
		{ value: "10", title: "Oktober" },
		{ value: "11", title: "November" },
		{ value: "12", title: "Dezember" }
	];
	
	constructor( props )
	{
		super( props );
		let billingMonthOptions = [];
		
		for ( let i = 0; i <= this.currentTime.getMonth(); i++ )
		{
			billingMonthOptions.push( this.defaultBillingMonthOptions[ i ] );
		}
		
		this.state = {
			form: {},
			billingMonthOptions: billingMonthOptions
		};
		
		this.handleEdit = this.handleEdit.bind( this );
		
	} // function constructor(...)
	
	componentDidMount()
	{
		this.props.setTitleAndScrollToTop( "Organisationsverwaltung" );
		
		if ( this.props.organizations.length === 0 && Access.isPermitted( this.props.organizations, [ "get_organizations" ] ) )
		{
			this.props.getOrganizationsOverview();
		}
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.pageview( "/organisationsverwaltung" );
		}
		
	} // function componentDidMount()
	
	handleEdit( a_currentValues, a_newValues, a_optionalFields = [] )
	{
		if ( JSON.stringify( a_currentValues ) !== JSON.stringify( a_newValues ) )
		{
			const updatedValues = getUpdatedValues( a_currentValues, a_newValues );
			const requiredFields = a_optionalFields.length === 0
				? updatedValues
				: Object.keys( updatedValues ).filter( a_field => a_optionalFields.indexOf( a_field ) === -1 );
			
			if ( updatedValues.length === 0 || requiredFields.length === 0 )
			{
				return this.props.message( "Es liegen keine Änderungen vor." );
			}
			
			// Nur die Änderungen aktualisieren
			this.props.patchOrganization( updatedValues, a_newValues );
		}
		
	} // function handleEdit(...)
	
	handleEditPayment( a_currentValues, a_newValues )
	{
		let valid = false;
		
		// Prüfung auf richtigkeit der IBAN
		this.props.checkIBAN( a_newValues ).then(
			result =>
			{
				if ( result )
				{
					this.handleEdit( a_currentValues, a_newValues, [ "sepa_approval" ] );
					return valid = true;
				}
				
			}
		);
		
		return valid;
		
	} // function handleEditPayment(...)
	
	handleDelete( values )
	{
		if ( values.id === this.props.user.organization.id )
		{
			return this.props.message( "Sie sind nicht Berechtigt Ihre Organisation zu löschen!" );
		}
		
		this.props.deleteOrganization( values.id );
		
	} // function handleDelete()
	
	handleExportOrganization( currentValues )
	{
		this.props.getOrganization( currentValues, "csv" );
		
	} // function handleExportOrganization()
	
	handleAnonymizeIban( currentValues )
	{
		this.props.anonymizeIban( currentValues );
		
	} // function handleAnonymizeIban()
	
	handleExportOrganizationBilling( currentValues, newValues )
	{
		this.props.exportOrganizationBilling( {
			organization_id: currentValues.id,
			month: newValues.month,
			year: newValues.year
		} );
		
	} // function handleExportOrganizationBilling()
	
	handleExportOrganizationsBilling( a_form_ref )
	{
		if ( this.refs.hasOwnProperty( a_form_ref ) )
		{
			this.props.exportOrganizationsBilling( this.refs[ a_form_ref ].state );
		}
		
	} // function handleExportOrganizationsBilling()
	
	handleActivate( currentValues )
	{
		const updatedValues = { active: !currentValues.active, order_status: !currentValues.active ? "entsperrt" : "gesperrt" };
		const newValues = Object.assign(
			{},
			currentValues,
			updatedValues
		);
		
		// Änderungen aktualisieren
		this.props.patchOrganization( updatedValues, newValues );
		
	} // function handleActivate()
	
	render()
	{
		const { organizations } = { ...this.props };
		
		const billingFields = [
			{
				name: "month",
				title: "Monat",
				type: "select",
				required: true,
				options: [
					{ value: 1, title: "Januar" },
					{ value: 2, title: "Februar" },
					{ value: 3, title: "März" },
					{ value: 4, title: "April" },
					{ value: 5, title: "Mai" },
					{ value: 6, title: "Juni" },
					{ value: 7, title: "Juli" },
					{ value: 8, title: "August" },
					{ value: 9, title: "September" },
					{ value: 10, title: "Oktober" },
					{ value: 11, title: "November" },
					{ value: 12, title: "Dezember" }
				],
				className: "col s12 m5 l4 xl8",
				cleared: true
			},
			{
				name: "year",
				title: "Jahr",
				type: "select",
				required: true,
				options: [
					{ value: 2019, title: "2019" },
					{ value: 2020, title: "2020" }
				],
				className: "col s12 m5 l4 xl8",
				cleared: true
			}
		];
		
		const formFields = [
			{
				name: "name",
				title: "Organisationsname",
				type: "text",
				required: true,
				className: "col s12 xl6",
				maxLength: "80",
				autoFocus: true
			},
			{
				name: "vat_id",
				title: "Umsatzsteuer-IdNr.",
				type: "text",
				required: true,
				className: "col s12 m6 xl3",
				maxLength: "20"
			},
			{
				name: "phone_number",
				title: "Telefonnummer",
				type: "tel",
				required: true,
				className: "col s12 m6 xl3",
				cleared: true,
				maxLength: "50"
			},
			{
				name: "street",
				title: "Straße",
				type: "text",
				required: true,
				className: "col s12 m8 l4",
				maxLength: "50"
			},
			{
				name: "street_number",
				title: "Hausnummer",
				type: "text",
				required: true,
				className: "col s12 m4 l2",
				maxLength: "24"
			},
			{
				name: "postal_code",
				title: "Postleitzahl",
				type: "text",
				required: true,
				className: "col s12 m4 l2",
				maxLength: "10"
			},
			{
				name: "city",
				title: "Ort",
				type: "text",
				required: true,
				className: "col s12 m8 l4",
				maxLength: "50"
			},
			{
				name: "order_status",
				title: "Status",
				type: "select",
				options: [
					{ value: "bestellt", title: "bestellt" },
					{ value: "bezahlt", title: "bezahlt" },
					{ value: "gesperrt", title: "gesperrt" },
					{ value: "entsperrt", title: "entsperrt" }
				],
				permissions: [ "get_faktura_organizations" ],
				className: "col s12 m5 l4 xl2"
			}
		];
		
		const editPaymentFields = [
			{
				name: "account_owner",
				title: "Kontoinhaber",
				maxLength: "80",
				type: "text",
				required: true,
				className: "col s12 m4 l4 xl4"
			},
			{
				name: "iban",
				title: "IBAN",
				maxLength: "50",
				type: "text",
				required: true,
				className: "col s12 m5 l4 xl5"
			},
			{
				name: "credit_institution",
				title: "BIC",
				maxLength: "50",
				type: "text",
				required: true,
				className: "col s12 m3 l4 xl3",
				cleared: true
			},
			{
				name: "sepa_approval",
				title: "Lastschrifteinzug akzeptieren",
				options: <span>Ich ermächtige Zahlungen von meinem Konto mittels Lastschrift einzuziehen.<br/>
						      Zugleich weise ich mein Kreditinstitut an, die von {translations.de_DE.words.appName} auf mein Konto gezogenen Lastschriften einzulösen.</span>,
				type: "checkbox",
				className: "col s12",
				required: true
			}
		];
		
		// Jahres Optionen
		let years = [];
		let startYear = this.currentTime.getFullYear();
		
		let billingYearOptions = [];
		
		organizations && Object.keys( organizations ).forEach(
			( a_key ) =>
			{
				const organization = organizations[ a_key ];
				const year = organization[ "ordered_at" ] ? new Date( organization[ "ordered_at" ] ).getFullYear() : null;
				const month = organization[ "ordered_at" ] ? new Date( organization[ "ordered_at" ] ).getMonth() : null;
				
				years[ year ] = month + 1;
				
				if ( year && this.currentTime.getFullYear() > year )
				{
					startYear = year;
				}
			}
		);
		
		for ( startYear; startYear <= this.currentTime.getFullYear(); startYear++ )
		{
			billingYearOptions.push( { value: startYear, title: startYear } );
		}
		
		return <article>
			{
				Object.keys( organizations ).length > 0 &&
				<Access permissions={[ "get_faktura_organizations" ]}>
					<section className={"unset-margin"}>
					<div className={"col s12 tRight"}>
						<Form
							id={`form_export_billings`}
							ref={`form_export_billings`}
							
							modalTitle={"Exportiere Rechnungen für den ausgewählten Zeitraum"}
							modalClass={"confirm tLeft"}
							modalTrigger={
								<button title={"Exportiere Rechnungen für den ausgewählten Zeitraum"} className={"btn btn-middle icon-shadow unset-margin"}>
									<Icon iconName={"money"}/>
									<span>Exportiere alle Rechnungen</span>
								</button>
							}
							
							errorMessage={( a_message, a_type, a_timeout ) => this.props.message( a_message, a_type, a_timeout )}
							onSubmit={() => this.handleExportOrganizationsBilling( "form_export_billings" )}
							submitValue={[
								<Icon size={14} key={`form-edit-icon`} iconName={"money"}/>,
								<span key={`form-edit-text`}>Alle Rechnungen exportieren</span>
							]}
							
							fields={[
								{
									name: "billing_year",
									title: "Jahr",
									type: "select",
									// Optionen dynamisch ermitteln
									options: billingYearOptions,
									required: true,
									className: "col s12 m6",
									onValidChange: ( a_year ) =>
									{
										let billingMonthOptions = [];
										
										if ( a_year === this.currentTime.getFullYear().toString() )
										{
											for ( let i = 0; i <= this.currentTime.getMonth(); i++ )
											{
												billingMonthOptions.push( this.defaultBillingMonthOptions[ i ] );
											}
										}
										else
										{
											let months = [];
											Object.keys( organizations ).forEach(
												( a_key ) =>
												{
													const organization = organizations[ a_key ];
													const year = organization[ "ordered_at" ] ? new Date( organization[ "ordered_at" ] ).getFullYear().toString() : null;
													if ( year && a_year === year && organization[ "ordered_at" ] &&
														!months.hasOwnProperty( new Date( organization[ "ordered_at" ] ).getMonth() ) )
													{
														for ( let month = new Date( organization[ "ordered_at" ] ).getMonth(); month < 12; month++ )
														{
															months[ month ] = month;
														}
													}
												}
											);
											months.forEach( ( a_month ) => billingMonthOptions.push( this.defaultBillingMonthOptions[ a_month ] ) );
										}
										
										this.setState( { billingMonthOptions: billingMonthOptions } );
										
										return true;
									}
								},
								{
									name: "billing_month",
									title: "Monat",
									type: "select",
									// Optionen dynamisch ermitteln
									options: this.state.billingMonthOptions,
									required: true,
									cleared: true,
									className: "col s12 m6"
								}
							]}
							values={{ billing_year: this.currentTime.getFullYear(), billing_month: this.currentTime.getMonth() + 1 }}
						/>
					</div>
				</section>
				</Access>
				
			}
			<section className={"white"}>
				<div className={"col s12"}>
					{
						Object.keys( organizations ).length > 0 &&
						<Overview title={"Organisationen"}
						          sortBy={"name"}
						          list={organizations}
						          className={"unset-margin"}
						          classNameItem={"white-grey"}
						          classNameDataBlock={"col s12 l10 unset-padding"}
						          classNameTriggerBlock={"col s12 l2 tRight"}
						          permissionsToShow={[ "get_faktura_organization", "get_organizations" ]}
						          listFields={
							          [
								          {
									          name: "customer_number",
									          title: "Kundennummer",
									          sortable: true,
									          className: "col s6 m3 l4 xl2"
								          },
								          {
									          name: "name",
									          title: "Organisationsname",
									          sortable: true,
									          className: "col s12 m5 l4 xl3"
								          },
								          {
									          name: [ [ "street", "street_number" ], [ "postal_code", "city" ] ],
									          title: "Anschrift",
									          className: "col s12 m4 l4 xl3"
								          },
								          {
									          name: "vat_id",
									          title: "USt.-Id.",
									          className: "col s12 m3 l4 xl2 cleared-m cleared-l",
									          permissions: [ "get_faktura_organization", "get_faktura_organizations" ]
								          },
								          {
									          name: "phone_number",
									          title: "Telefonnummer",
									          className: "col s12 m5 l4 xl2",
									          cleared: true
								          },
								          {
									          name: "order_status",
									          title: "Status",
									          className: "col s6 m3 l4 xl2",
									          permissions: [ "get_faktura_organization", "get_faktura_organizations" ],
									          sortable: true
								          },
								          {
									          name: "account_owner",
									          title: "Kontoinhaber",
									          className: "col s12 m4 l4 xl3",
									          permissions: [ "get_faktura_organization", "get_faktura_organizations" ]
								          },
								          {
									          name: "iban",
									          title: "IBAN",
									          className: "col s12 m5 l4 xl3",
									          permissions: [ "get_faktura_organization", "get_faktura_organizations" ]
								          },
								          {
									          name: "credit_institution",
									          title: "BIC",
									          className: "col s12 m3 l4 xl2",
									          permissions: [ "get_faktura_organization", "get_faktura_organizations" ],
									          cleared: true
								          },
								          {
									          name: "survey_costs",
									          title: "Recherchenkosten",
									          className: "col s12 m3 l4 xl2",
									          permissions: [ "get_faktura_organizations" ],
									          // TODO Richtige Sortierung von Zahlen
									          // sortable: true,
									          format: "price"
								          },
								          {
									          name: "basic_charge",
									          title: "Grundgebühr",
									          className: "col s12 m5 l4 xl3",
									          permissions: [ "get_faktura_organizations" ],
									          format: "price"
								          },
								          {
									          name: "monthly_limit",
									          title: "Monatliches Kostenlimit",
									          className: "col s12 m4 l4 xl3",
									          permissions: [ "get_faktura_organizations" ],
									          format: "price",
									          cleared: true
								          }
							          ]
						          }
						          trigger={
							          [
								          {
									          key: "edit",
									          icon: "edit",
									          submitButtonText: "Ändern",
									          title: "Organisation bearbeiten",
									          iconTitle: "Organisation bearbeiten",
									          iconClassName: "white primary-color-text hover-primary-color hover-white-text",
									          permissions: [ "patch_organization" ],
									          formFields: formFields,
									          onClick: this.handleEdit.bind( this )
								          },
								          {
									          key: "editPayment",
									          icon: "payment",
									          submitButtonText: "Ändern",
									          title: "Zahlungsdaten bearbeiten",
									          iconTitle: "Zahlungsdaten bearbeiten",
									          iconClassName: "white primary-color-text hover-primary-color hover-white-text",
									          permissions: [ "patch_organization_billing" ],
									          formFields: editPaymentFields,
									          additionalFormHtml: <div className={"relative"}>
										          <div className={"col s12 primary-color white-text seperator"}>
											          <h6>Hinweis</h6>
										          </div>
										          <div className={"col s12 unset-padding dashed-block hasTitle"}>
											          <div className={"col s12"}>
												          <p>Vor dem Einzug einer SEPA-Basis-Lastschrift werden wir Sie über den Einzug in dieser Verfahrensart unterrichten.</p>
												          <p>Sie können jederzeit innerhalb von acht Wochen, beginnend mit dem Belastungsdatum,
													          die Einzungsermächtigung schriftlich widerrufen und die Erstattung
													          des belasteten Betrags verlangen.
													          <br/>Es gelten dabei die mit Ihrem Kreditinstitut vereinbarten Bedingungen.</p>
												          <p>Im Falle einer Nichteinlösung einer Lastschrift ist {translations.de_DE.words.appName} berechtigt, ohne weitere
													          Information oder Ankündigung den Zugang des
													          Teilnehmers
													          zum imera.esch.design zu sperren und/oder den Vertrag fristlos zu kündigen. Für die von Ihnen verschuldeten Rückbuchungen
													          der Bankeinzüge
													          oder
													          Kreditkartenabbuchungen berechnen wir Ihnen eine Gebühr von EUR 8,00. Ihnen bleibt der Nachweis eines geringeren oder
													          gar keines Schadens
													          vorbehalten. Ausgenommen hiervon ist der begründete Widerspruch gegen eine Lastschrift.</p>
											          </div>
										          </div>
										          <div className={"col s12 seperator"}/>
									          </div>,
									          onClick: this.handleEditPayment.bind( this )
								          },
								          {
									          key: [ "unlocked", "locked" ],
									          icon: [ "unlocked", "locked" ],
									          submitButtonText: [ "Organisation deaktivieren", "Organisation aktivieren" ],
									          fieldName: { key: "active", value: false },
									          iconTitle: [ "Organisation deaktivieren", "Organisation aktivieren" ],
									          iconClassName: [
										          "white primary-color-text hover-primary-color hover-white-text",
										          "white primary-color-text hover-primary-color hover-white-text"
									          ],
									          permissions: [ "activate_organization" ],
									          submitText: [ "Soll die Organisation deaktiviert werden?", "Soll die Organisation aktiviert werden?" ],
									          onClick: this.handleActivate.bind( this )
								          },
								          {
									          key: "money",
									          icon: "money",
									          submitButtonText: "Rechnung exportieren",
									          iconTitle: "aktuelle Rechnung exportieren",
									          iconClassName: "white primary-color-text hover-primary-color hover-white-text",
									          permissions: [ "get_organization_billing" ],
									          formFields: billingFields,
									          onClick: this.handleExportOrganizationBilling.bind( this )
								          },
								          {
									          key: "export",
									          icon: "export",
									          submitButtonText: "Organisation exportieren",
									          iconTitle: "Organisationsdaten exportieren",
									          iconClassName: "white primary-color-text hover-primary-color hover-white-text",
									          permissions: [ "export_organization" ],
									          submitText: "Soll die Organisation exportiert werden?",
									          onClick: this.handleExportOrganization.bind( this ),
									          disableOnSubstring: { key: "iban", value: "XXXX" }
								          },
								          {
									          key: "anonymize",
									          icon: "protect",
									          submitButtonText: "IBAN anonymisieren",
									          iconTitle: "IBAN anonymisieren",
									          iconClassName: "white primary-color-text hover-primary-color hover-white-text",
									          permissions: [ "anonymize_organization_billing" ],
									          submitText: "Soll die IBAN anonymisiert werden?",
									          onClick: this.handleAnonymizeIban.bind( this ),
									          disableOnEmpty: "iban",
									          disableOnSubstring: { key: "iban", value: "XXXX" }
								          },
								          {
									          key: "delete",
									          icon: "delete",
									          submitButtonText: "Ja",
									          cancelButtonText: "Nein",
									          iconTitle: "Organisation löschen",
									          iconClassName: "white red-text hover-red hover-white-text",
									          permissions: [ "delete_organization" ],
									          submitText: "Soll die Organisation gelöscht werden?",
									          onClick: this.handleDelete.bind( this ),
									          disableOnSubstring: { key: "id", value: this.props.user.organization.id }
								          }
							          ]
						          }
						/>
					}
				</div>
			</section>
		</article>;
		
	} // function render()
	
} // class

OrganizationManagement = connect(
	mapStateToProps,
	mapDispatchToProps
)( OrganizationManagement );

export default OrganizationManagement;
